import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {useTranslate} from '@computerrock/formation-i18n';
import {useStyles} from '@ace-de/ui-components';
import {DateField, TimeField, Checkbox, ButtonPrimary} from '@ace-de/ui-components/form';
import {Icon, calendarIcon, emailIcon} from '@ace-de/ui-components/icons';
import styles from '../modals/CommunicationModals.module.scss';

const TaskSection = props => {
    const {cx} = useStyles(props, styles);
    const {isTaskCreationEnabled, setIsTaskCreationEnabled, dueDate, setDueDate} = props;
    const {dueTime, setDueTime, isDueTimeValid, setIsDueTimeValid} = props;
    const {isSendingDisabled, isSendingInProgress, onSend} = props;
    const {areTaskFieldsVisible} = props;
    const {createTranslateShorthand} = useTranslate();
    const translateModal = createTranslateShorthand('send_message_modal');

    return (
        <>
            {areTaskFieldsVisible && (
                <Fragment>
                    <Checkbox
                        name="createTask"
                        value={true}
                        className={cx('global!ace-u-margin--bottom-24')}
                        onChange={setIsTaskCreationEnabled}
                        isSelected={!!isTaskCreationEnabled}
                        isDisabled={isSendingInProgress}
                    >
                        {translateModal('checkbox_label.create_task')}
                    </Checkbox>
                    <DateField
                        name="dueDate"
                        icon={calendarIcon}
                        label={`${translateModal('date_field_label.due_date')}${isTaskCreationEnabled ? '*' : ''}`}
                        value={dueDate}
                        onChange={setDueDate}
                        className={cx('global!ace-u-margin--bottom-8')}
                        isDisabled={isSendingInProgress}
                    />
                    <TimeField
                        name="dueTime"
                        label={`${translateModal('time_field_label.due_time')}${isTaskCreationEnabled ? '*' : ''}`}
                        value={dueTime}
                        onChange={setDueTime}
                        isDisabled={isSendingInProgress}
                        isInvalid={dueTime ? !isDueTimeValid : false}
                        handleValidation={setIsDueTimeValid}
                    />
                </Fragment>
            )}
            <ButtonPrimary
                className={cx('global!ace-u-margin--top-16')}
                isDisabled={isSendingDisabled || isSendingInProgress}
                onClick={onSend}
            >
                <Icon
                    icon={emailIcon}
                    className={cx([
                        'global!ace-c-icon--color-contrast',
                        'global!ace-u-margin--right-8',
                    ])}
                />
                {translateModal('button_label.send_message')}
            </ButtonPrimary>
        </>
    );
};

TaskSection.propTypes = {
    isTaskCreationEnabled: PropTypes.bool.isRequired,
    setIsTaskCreationEnabled: PropTypes.func.isRequired,
    dueDate: PropTypes.string.isRequired,
    setDueDate: PropTypes.func.isRequired,
    dueTime: PropTypes.string.isRequired,
    setDueTime: PropTypes.func.isRequired,
    isDueTimeValid: PropTypes.bool,
    setIsDueTimeValid: PropTypes.func.isRequired,
    isSendingDisabled: PropTypes.bool.isRequired,
    isSendingInProgress: PropTypes.bool.isRequired,
    onSend: PropTypes.func.isRequired,
    areTaskFieldsVisible: PropTypes.bool,
};

TaskSection.defaultProps = {
    isDueTimeValid: undefined,
    areTaskFieldsVisible: true,
};

export default TaskSection;
